module.exports = __webpack_public_path__ + "static/img/5.265c0dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/5.png
// module id = v4QK
// module chunks = 1